import { OfficeFolders, Offices } from "../Components/index.js";

export default [
    {
        path: "/reports/letter/office/:office_id/folder",
        component: OfficeFolders,
        name: "report.letter.office-folder",
        meta: {
            requiresAuth: true,
        },
    },
];
